import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { switchMap } from "rxjs/operators";
import { Utils } from "src/app/common/utils";
import { DashCred } from "src/app/models/dash";
import { VproService } from "src/app/service/vpro/vpro.service";
import Swal from "sweetalert2";
import { Extend } from "./../../models/extend";
import { ConfirmedValidator } from '../../common/passwordValidator';
import { TextboxField } from "src/app/forms/models/field-textbox";
import { DateField } from "src/app/forms/models/field-date";
import { DropdownField } from "src/app/forms/models/field-dropdown";
import { TextareaField } from "src/app/forms/models/field-textarea";
import { FieldControlService } from "src/app/forms/models/field-control.service";
import { Location } from '@angular/common';
import { User } from "src/app/models/user";

@Component({
  selector: "app-fdesk-profile",
  templateUrl: "./fdesk-profile.component.html",
  styleUrls: ["./fdesk-profile.component.scss"],
  providers: [FieldControlService],
})
export class FdeskProfileComponent implements OnInit {

  user = new User();
  showMore: boolean = false;
  submitted = false;
  orgdet: any;
  dcred = new DashCred();
  usereid: string;
  extend = new Extend();
  ppfile: File = null;
  states = null;
  ppurl: String = "";
  pp_content_type: String = "";
  frontDeskCurrentTab: string = "personalInformation";
  dataValue2: any;
  innerHtml: string = "";


  frontDeskListofTab: any[] = [
    {
      id: "personalInformation",
      title: "Personal Info",
    },
    {
      id: "contactDetails",
      title: "Contact Details",
    },
    {
      id: "additionalInformation",
      title: "Additional Information",
    },
  ];
  forms = {
    personalInformation: null,
    contactDetails: null,
    additionalInformation: null,
  };
  // maxDate = Utils.maxDate;
  form_fields = {
    personalInformation: [
      new TextboxField({
        key: "first_name",
        label: "First Name",
        required: true,
        maxlength: 30,
        class: "col-12 col-sm-12 col-md-12 col-lg-12",
        pattern: Utils.alphaSpaceRegex,
      }),
      new TextboxField({
        key: "last_name",
        label: "Last Name",
        required: true,
        type: "text",
        maxlength: 30,
        class: "col-12 col-sm-12 col-md-12 col-lg-12",
        pattern: Utils.alphaSpaceRegex,
      }),
      new TextboxField({
        key: "password",
        label: "Password",
        required: true,
        type: "password",
        maxlength: 80,
        class: "col-12 col-sm-12 col-md-12 col-lg-12",
      }),
      new TextboxField({
        key: "cnfrm_password",
        label: "Confirm password",
        required: true,
        type: "password",
        maxlength: 80,
        class: "col-12 col-sm-12 col-md-12 col-lg-12",
      }),

      new DateField({
        key: "dob",
        label: "Date of Birth (DD/MM/YYYY)",
        required: true,
        class: "col-12 col-sm-12 col-md-12 col-lg-12",
        maxDate: Utils.maxDate
      }),
    ],
    contactDetails: [
      new TextboxField({
        key: "address_1",
        label: "Address Line 1",
        maxlength: 150,
        class: "col-12 col-sm-12 col-md-6 col-lg-6",
      }),
      new TextboxField({
        key: "address_2",
        label: "Address Line 2",
        maxlength: 150,
        class: "col-12 col-sm-12 col-md-6 col-lg-6",
      }),
      new TextboxField({
        key: "city",
        label: "City",
        maxlength: 30,
        class: "col-12 col-sm-12 col-md-4 col-lg-4",
        required: true,
        pattern: Utils.alphaRegex,
      }),
      new DropdownField({
        key: "state",
        label: "State",
        options: this.addFdeskService.getStates(1),
        class: "col-12 col-sm-12 col-md-4 col-lg-4",
        required: true,
      }),
      new TextboxField({
        key: "zip",
        type: "tel",
        label: "Zip",
        maxlength: 6,
        minlength: 6,
        pattern: Utils.numberRegex,
        class: "col-12 col-sm-12 col-md-4 col-lg-4",
        required: true,
      }),
      new TextboxField({
        key: "contact_no",
        type: "tel",
        label: "Contact Number",
        class: "col-12 col-sm-12 col-md-4 col-lg-4",
        required: true,
        pattern: Utils.numberRegex,
        maxlength: 10,
        minlength: 10,
      }),
      new TextboxField({
        key: "email_id",
        type: "email",
        label: "Email",
        required: true,
        class: "col-12 col-sm-12 col-md-4 col-lg-4",
        maxlength: 50,
        pattern: Utils.emailpat,

      }),
      new TextboxField({
        key: "cnfrm_email_id",
        type: "email",
        label: "Confirm Email (App Communications)",
        required: true,
        class: "col-12 col-sm-12 col-md-4 col-lg-4",
        maxlength: 50,
        pattern: Utils.emailpat,
      }),
    ],
    additionalInformation: [
      new TextareaField({
        key: "additional_info",
        label: "Message",
        minRows: 5,
        class: "col-12 col-sm-12",
      }),
    ],
  };

  constructor(
    private addFdeskService: VproService,
    private formService: FieldControlService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private location: Location
  ) {
    for (let form_field in this.form_fields) {
      if (form_field == "personalInformation") {
        this.forms[form_field] = this.formService.toFormGroup(
          this.form_fields[form_field], ConfirmedValidator, ['password', 'cnfrm_password']
        );
      } else if (form_field == "contactDetails") {
        this.forms[form_field] = this.formService.toFormGroup(
          this.form_fields[form_field],
          ConfirmedValidator,
          ["email_id", "cnfrm_email_id"],

        );
      } else {
        this.forms[form_field] = this.formService.toFormGroup(
          this.form_fields[form_field]
        );
      }
    }
  }

  ngOnInit() {
    this.getOrgDet(localStorage.getItem("LogUsr"));
    this.loadStates();
  }

  loadStates() {
    this.addFdeskService.getStates(1).subscribe((res) => {
      this.states = res;
    });
  }

  get f() {
    return this.forms[this.frontDeskCurrentTab].controls;
  }

  getOrgDet(usereid: string) {
    try {
      this.addFdeskService.getOrgDet(this.dcred).subscribe(
        (res) => {
          this.orgdet = res;
          for (let i of this.orgdet) {
            this.extend.org_code = i.org_code;
          }
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (excep) {
      console.log(excep);
    }
  }

  show() {
    this.showMore = true;
    this.extend.email = localStorage.getItem("usethis");
    this.extend.altemail = localStorage.getItem("LogUsr");
    this.extend.first_name = localStorage.getItem("fname");
    this.extend.last_name = localStorage.getItem("lname");
  }

  /** Function to save Front desk data */
  public saveFrontDesk(): void {
    // Create the JSON to be send to backend
    let data = {
      ...this.forms.personalInformation.value,
      ...this.forms.contactDetails.value,
      ...this.forms.additionalInformation.value,
      role_name: "front desk",
      org_code: this.extend.org_code,
    };

    if (data.first_name && data.last_name) {
      data.first_name = data.first_name.charAt(0).toUpperCase() + data.first_name.slice(1).toLowerCase();
      data.last_name = data.last_name.charAt(0).toUpperCase() + data.last_name.slice(1).toLowerCase();
    }

    if (data.email_id) {
      data.email_id = data.email_id.toLowerCase();
    }

    if (data.dob) {
      data.dob = `${data.dob.year}-${data.dob.month}-${data.dob.day}`;
    }
    if (this.ppurl && this.pp_content_type) {
      data.ppurl = this.ppurl;
      data.pp_content_type = this.pp_content_type;
    }
    // Remove any empy fields
    delete data.cnfrm_password;
    delete data.cnfrm_email_id;

    data = Utils.removeNullAndEmpty(data);

    console.log(data);
    this.spinner.show();

    this.addFdeskService
      .mailUser({
        user_type: Utils.USER_TYPE.front_desk,
        email_id: data.email_id,
        password: data.password,
        first_name: this.forms.personalInformation.value.first_name,
        last_name: this.forms.personalInformation.value.last_name,
        account_type: Utils.ALLOWED_TYPE.HEALTHCARE_PROVIDER
      })
      .pipe(
        switchMap((payment) => {
          return this.addFdeskService.addFrontDesk(data, this.ppfile);
        })
      )
      .subscribe(
        () => {
          this.spinner.hide();
          // SweetAlert

          const Toast = Swal.mixin({
            toast: true,
            position: "top",
            showConfirmButton: false,
            timer: 3500,
          });

          Toast.fire({
            type: "success",
            title: "Front-desk profile has been created successfuly",
          });
          this.router.navigate(["/profile"]);
        },
        (error) => {
          this.spinner.hide();
          const Toast = Swal.mixin({
            toast: true,
            position: "top",
            showConfirmButton: false,
            timer: 3500,
          });
          Toast.fire({
            type: "error",
            title: "Something went wrong. Please try again later.",
          });
        }
      );
  }

  public fileSelected(files) {
    if (files[0].type && files[0].type.indexOf('image') === -1) {
      const Toast = Swal.mixin({
        position: 'top',
        showConfirmButton: true,
        allowOutsideClick: false,


      });

      Toast.fire({
        type: 'warning',
        title: 'Only .png/.jpeg/.jpg format is allowed',

      });

    }
    console.log(files);
    if (files && files.length > 0) {
      this.ppfile = files[0];

      this.ppurl = files[0].name;
      this.pp_content_type = files[0].type;
    }
  }
  /** assign tabs based on click */
  public frontDeskAssignTab(tabName: string): void {
    this.frontDeskCurrentTab = tabName;
  }
  /** next tabs based on next click by user */
  public frontDeskNextTab(): void {
    let index = this.frontDeskListofTab.findIndex((t: any) => t.id === this.frontDeskCurrentTab);
    this.frontDeskCurrentTab = this.frontDeskListofTab[index + 1].id;
  }
  /** get previous tabname and info */
  public frontDeskPreviousTab(): void {
    let index = this.frontDeskListofTab.findIndex((t: any) => t.id === this.frontDeskCurrentTab);
    this.frontDeskCurrentTab = this.frontDeskListofTab[index - 1].id;
  }

  getback() {
    this.location.back();
  }

  checkEid() {
    try {
      this.addFdeskService.authUser2(this.user).subscribe(
        data => {
          this.dataValue2 = data["utype"];

          if (this.dataValue2 !== 8) {
            this.innerHtml =
              "This email-id is already registered with us, please use another !";

            document.getElementById("email_id").focus();
          } else {
            this.innerHtml = "";

            document.getElementById("email_id").blur();
          }
        },
        error => {
          console.log(error);
        }
      );
    } catch (excep) {
      console.log(excep);
    }
  }
}
